import React, { Component } from "react";
import NavBar from "./components/navbar";
import Counters from "./components/counters";

class App extends Component {
  state = {
    counters: [
      { id: 1, value: 0, channel: "will"  , readOnly: true},
      { id: 2, value: 0, channel: "chat"  , readOnly: false},
    ],
    channelToBe : "new channel",
    isChecked : false
  };

  handleIncrement = counter => {
    const counters = [...this.state.counters];
    const index = counters.indexOf(counter);
    counters[index] = { ...counters[index] };
    counters[index].value++;
    this.setState({ counters });
  };

  handleDecrement = counter => {
    const counters = [...this.state.counters];
    const index = counters.indexOf(counter);
    counters[index] = { ...counters[index] };
    counters[index].value--;
    this.setState({ counters });
  };

  handleReset = () => {
    const counters = this.state.counters.map(c => {
      c.value = 0;
      return c;
    });
    this.setState({ counters });
  };

  handleDelete = counterId => {
    const counters = this.state.counters.filter(c => c.id !== counterId);
    this.setState({ counters });
  };

  handleAdd = (readonly) => {
    const maxId = this.state.counters
    .map(x => x.id)
    .reduce((prev, cur) => Math.max(prev, cur)) + 1;

    const fucker = this.state.channelToBe


    this.state.counters.push({id:maxId, value:0, channel: fucker, readOnly : readonly});
    const counters = this.state.counters;
    this.setState({ counters });
  }

  handleRestart = () => {
    window.location.reload();
  };

  handleChange(event) {
    this.setState({channelToBe: event.target.value})
  }

  toggelCheckBox(event) {
    const isChecked = this.state.isChecked
    this.setState(({  isChecked: !isChecked }));
  }

  render() {
    return (
      <div>
        <h1>
          Welcome to msgb.us
        </h1>
        <main className="container">
          <Counters
            counters={this.state.counters}
            onReset={this.handleReset}
            onIncrement={this.handleIncrement}
            onDecrement={this.handleDecrement}
            onDelete={this.handleDelete}
            onRestart={this.handleRestart}
          />
        </main>
        <form  onSubmit={e => {e.preventDefault();this.handleAdd(this.state.isChecked)}}>
        <input type="submit" value="Subscribe to channel" />
        <input className="col-md-2" type='text' placeholder={this.state.channelToBe} id='channel-to-add' onChange={this.handleChange.bind(this)}/>
        <input type="checkbox" name="readOnly" value="Read Only?" checked={this.state.isChecked} onChange={this.toggelCheckBox.bind(this)}/>
        </form>
        
      </div>
    );
  }
}

export default App;
